export { default } from '../../src/features/setup/screens/AuthCompleteScreen'
